<template>
    <div>
        <section class="edit-profile-section mt-4_5">
            <div class="display-picture-container">
                <div
                        @click="openFileUpload"
                        class="display-picture"
                        @mouseenter="isOverlay = true"
                        @mouseleave="isOverlay = false"
                >
                    <img :src="form.image_url" alt="" v-if="form.image_url"/>
                    <img src="/img/user-placeholder.png" alt="" v-else/>
                    <div class="edit-overlay" :class="isOverlay ? 'hover' : ''">
                        <font-awesome-icon icon="camera"></font-awesome-icon>
                    </div>
                    <input
                            type="file"
                            id="FileUpload"
                            style="display: none"
                            @change="uploadPhoto"
                            accept="image/*"
                    />
                </div>
            </div>
            <h1 class="heading squiggly-line-color line-center">Edit Profile</h1>
            <div class="form-block">
                <b-form data-vv-scope="edit">
                    <b-row>
                        <b-col cols="12">
                            <b-form-group
                                    id="input-group-2"
                                    label="Your Name"
                                    label-for="input-2"
                            >
                                <b-form-input
                                        id="input-2"
                                        v-model.trim="form.name"
                                        required
                                        placeholder="Name"
                                        v-validate="'required|max:20|min:3|alpha_spaces'"
                                        name="Name"
                                        :class="{ 'is-invalid': errors.has('edit.Name') }"
                                ></b-form-input>
                                <font-awesome-icon :icon="['far', 'edit']"></font-awesome-icon>
                                <b-form-invalid-feedback id="input-1-live-feedback">
                                    <small>{{ errors.first("edit.Name") }}</small>
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group
                                    id="input-group-1"
                                    label="Email address"
                                    label-for="input-1"
                                    description=""
                            >
                                <b-form-input
                                        id="input-1"
                                        v-model="form.email"
                                        type="email"
                                        required
                                        disabled
                                        placeholder="Email"
                                ></b-form-input>
                                <!--<font-awesome-icon :icon="['far', 'edit']"></font-awesome-icon>-->
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <b-form-group id="input-group-3" label="Phone" label-for="input-3">
                                <b-form-input
                                        id="input-3"
                                        v-model="form.mobile_number"
                                        required
                                        disabled
                                        placeholder="Mobile Number"
                                ></b-form-input>
                                <!--<font-awesome-icon :icon="['far', 'edit']"></font-awesome-icon>-->
                            </b-form-group>
                        </b-col>
                        <!--<b-col cols="6">-->
                        <!--<b-form-group id="input-group-4" label="Class" label-for="input-4">-->
                        <!--<b-form-input-->
                        <!--id="input-4"-->
                        <!--v-model="form.class"-->
                        <!--required-->
                        <!--placeholder="Class"-->
                        <!--&gt;</b-form-input>-->
                        <!--<font-awesome-icon :icon="['far', 'edit']"></font-awesome-icon>-->
                        <!--</b-form-group>-->
                        <!--</b-col>-->
                        <!--<b-col cols="6">-->
                        <!--<b-form-group-->
                        <!--id="input-group-5"-->
                        <!--label="Syllabus"-->
                        <!--label-for="input-5"-->
                        <!--&gt;-->
                        <!--<b-form-input-->
                        <!--id="input-5"-->
                        <!--v-model="form.syllabus"-->
                        <!--required-->
                        <!--placeholder="Syllabus"-->
                        <!--&gt;</b-form-input>-->
                        <!--<font-awesome-icon :icon="['far', 'edit']"></font-awesome-icon>-->
                        <!--</b-form-group>-->
                        <!--</b-col>-->
                        <b-col cols="12">
                            <b-form-group
                                    id="input-group-6"
                                    label="Location"
                                    label-for="input-6"
                            >
                                <b-form-input
                                        id="input-6"
                                        v-model="form.location"
                                        required
                                        placeholder="Location"
                                        v-validate="'required|alpha|min:3'"
                                        name="Location"
                                        :class="{
                  'is-invalid': errors.has('edit.Location')
                }"
                                ></b-form-input>
                                <font-awesome-icon :icon="['far', 'edit']"></font-awesome-icon>
                                <b-form-invalid-feedback id="input-8-live-feedback">
                                    <small>{{ errors.first("edit.Location") }}</small>
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <h4 class="mt-4 text-center small-heading">About You</h4>
                    <div class="interest-section">
                        <b-textarea v-model="form.short_description"
                                    placeholder="Enter something..."
                                    rows="5"
                                    max-rows="8"
                        ></b-textarea>
                    </div>
                    <h4 class="mt-4 text-center small-heading">Edit Interests</h4>
                    <div class="edit-interest-section">
                      <b-list-group>
                            <b-list-group-item v-for="(interest,i) in form.subject" :key="interest" class="edit-interest-item d-flex justify-content-between align-items-center">
                                <span>{{i+1}}. {{ interest }}</span>
                                <button class="btn text-danger btn-link" @click.prevent="removeSubject(i)">
                                    <font-awesome-icon icon="window-close"></font-awesome-icon>
                                </button>
                            </b-list-group-item>
                        </b-list-group>

                        <b-input-group class="mt-3">
                            <b-form-select
                                    v-model="subject"
                                    :options="subjects"
                                    :class="{'is-invalid': noSubjectSelected && subject === '' }"
                            ></b-form-select>
                            <template v-slot:append>
                        <b-button variant="primary" size="sm" @click="addSubject">
                            <font-awesome-icon icon="plus"></font-awesome-icon>
                        </b-button>
                            </template>
                        </b-input-group>
                    </div>
                    <h4 class="mt-4 text-center small-heading">Upload Cover Photo</h4>
                    <div class="col-12 mb-4 p-0 mt-4" style="position: relative;">
                        <img
                                :src="form.cover_photo"
                                style="width: 550px; height: 200px;outline: dashed 1px;"
                        />
                        <button class="btn-danger"
                                style="position: absolute ; top: 1px; right: 1px;"
                                v-if="form.cover_photo"
                                @click="form.cover_photo = ''"
                        >
                            <font-awesome-icon :icon="['far', 'edit']"/>
                            Edit Cover Photo
                        </button>
                        <label
                                for="add-video"
                                class=""
                                style="position: absolute; bottom: 85px;left: 230px"
                                v-else
                        >
                            <font-awesome-icon icon="plus"></font-awesome-icon>
                            <span>(Click here)</span>
                            <!--            add class file added when video file is selected-->
                            <b-form-file
                                    style="display: none"
                                    id="add-video"
                                    v-model="imageFile"
                                    class="mt-3"
                                    plain
                                    name="Cover Image"
                                    @change="uploadCoverImage"
                            >
                            </b-form-file>
                        </label>
                    </div>
                    <h4 class="mt-4 text-center small-heading">Upload Introduction Video</h4>
                    <div class="col-12 mb-4 p-0 mt-4" style="position: relative;">
                        <div style="width: 550px; height: 300px;outline: dashed 1px;">
                            <video
                                    :src="form.profile_video_url"
                                    autoplay
                                    style="width: 550px; height: 300px;"
                            ></video>
                        </div>
                        <button class="btn-danger"
                                style="position: absolute ; top: 1px; right: 1px;"
                                v-if="form.profile_video_url"
                                @click="form.profile_video_url = ''"
                        >
                            <font-awesome-icon :icon="['far', 'edit']"/>
                            Edit Video
                        </button>
                        <label
                                for="add-video1"
                                class=""
                                style="position: absolute; bottom: 130px;left: 230px"
                                v-else
                        >
                            <font-awesome-icon icon="plus"></font-awesome-icon>
                            <span>(Click here)</span>
                            <!--            add class file added when video file is selected-->
                            <b-form-file
                                    style="display: none"
                                    id="add-video1"
                                    class="mt-3"
                                    plain
                                    name="Introduction Video"
                                    @change="uploadVideo"
                            >
                            </b-form-file>
                        </label>
                    </div>

                    <div class="form-bottom">
                        <b-button
                                size="lg"
                                pill
                                variant="primary"
                                type="submit"
                                @click.prevent="action('edit')"
                                :disabled="disableButton"
                        >
                            <span>Save Changes</span>
                            <font-awesome-icon icon="arrow-right" size="xs"/>
                        </b-button>
                        <b-button @click="cancel" variant="link">Cancel Changes</b-button>
                    </div>
                </b-form>
            </div>
        </section>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import {customerApi} from "../../services/customerApi";
    import {teacherApi} from "../../services/teacherApi";

    export default {
        name: "edit-profile",
        data() {
            return {
                isOverlay: false,
                form: {
                    email: "",
                    name: "",
                    phone: "",
                    class: "",
                    syllabus: "",
                    location: "",
                    image_url: "",
                    subject: [],
                    resume: "",
                    profile_video_url: "",
                    cover_photo: "",
                    short_description: ""
                },
                foods: [
                    {text: "Select One", value: null},
                    "Carrots",
                    "Beans",
                    "Tomatoes",
                    "Corn"
                ],
                showEditError: false,
                disableButton: false,
                subjects: [],
                subject: "",
                noSubjectSelected: false
            };
        },
        computed: {
            ...mapGetters("user", ["getUserDetails", "getUserRole"]),
            ...mapGetters("category", ["getCategoryData"])
        },
        methods: {
            action(scope) {
                this.$validator.validateAll(scope).then(result => {
                    if (result) {
                        this.showEditError = false;
                        this.editUserDetails();
                    } else {
                        this.showEditError = true;
                    }
                });
            },
            openFileUpload() {
                const fileUpload = document.getElementById("FileUpload");
                fileUpload.click();
            },
            uploadPhoto(event) {
                this.disableButton = true;
                this.imageFile = event.target.files[0];
                const formData = new FormData();
                formData.append("document", this.imageFile);
                teacherApi.uploadResume(formData).then(res => {
                    this.form.image_url = res.bodyText;
                    this.disableButton = false;
                });
            },
            uploadVideo() {
                this.disableButton = true;
                this.imageFile = event.target.files[0];
                const formData = new FormData();
                formData.append("document", this.imageFile);
                teacherApi.uploadResume(formData).then(res => {
                    this.form.profile_video_url = res.bodyText;
                    this.disableButton = false;
                });
            },
            uploadCoverImage() {
                this.disableButton = true;
                this.imageFile = event.target.files[0];
                const formData = new FormData();
                formData.append("document", this.imageFile);
                teacherApi.uploadResume(formData).then(res => {
                    this.form.cover_photo = res.bodyText;
                    this.disableButton = false;
                });
            },
            resetData() {
                this.form.email = this.getUserDetails.email;
                this.form.name = this.getUserDetails.name;
                this.form.mobile_number = this.getUserDetails.phone;
                this.form.location = this.getUserDetails.location;
                this.form.image_url = this.getUserDetails.profile_photo;
                this.form.cover_photo = this.getUserDetails.cover_photo;
                this.form.profile_video_url = this.getUserDetails.profile_video_url;
                this.form.short_description = this.getUserDetails.short_description;
                this.form.subject = this.getUserDetails.subject;
                this.getCategoryData.forEach(category => {
                    category.sub_category.forEach(sub => {
                        this.subjects.push(sub.name);
                    });
                });
            },
            editUserDetails() {
                const userData = {
                    name: this.form.name,
                    location: this.form.location,
                    profile_photo: this.form.image_url,
                    email: this.form.email,
                    role: this.getUserRole,
                    // resume:this.form.resume,
                    subject:this.form.subject,
                    profile_video_url: this.form.profile_video_url,
                    cover_photo: this.form.cover_photo,
                    short_description: this.form.short_description
                };
                customerApi
                    .editCustomerDetails(userData)
                    .then(() => {
                        customerApi.getCustomerDetails(this.getUserRole);
                        this.$bvToast.toast(`Profile Updated successfully`, {
                            title: "Edit Profile",
                            autoHideDelay: 500,
                            appendToast: true
                        });
                        setTimeout(() => {
                            this.$router.push({
                                path: "/admin/dashboard",
                            });
                        }, 500);
                    })
                    .catch(() => {
                        this.$bvToast.toast(`Profile Update Failed`, {
                            title: "Edit Profile",
                            autoHideDelay: 500,
                            appendToast: true
                        });
                    });
            },
            cancel() {
                this.resetData();
                this.$router.push({
                    path: "/admin/dashboard",
                });
            },
            removeSubject(index){
                this.form.subject.splice(index, 1);
            },
            addSubject(){
                if(this.subject === ""){
                    this.noSubjectSelected = true;
                }else {

                    if (!(this.form.subject.some(sub => sub === this.subject))) {
                        this.form.subject.push(this.subject);
                    }
                    this.subject = "";
                    this.noSubjectSelected = false;
                }
            }
        },
        mounted() {
            this.resetData();
        }
    };
</script>

<style lang="scss">

</style>
